/**
 * Párrafo item
 * @param {*} editor
 */
function bold(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `/i${text}/f`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Resalte',
    action: bold,
    className: 'zmdi zmdi-format-bold',
    title: 'Resalte',
  };

  return option;
}
